import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionConsortiumPermissions extends BaseScenesPermissions {}

export default EmissionConsortiumPermissions
